import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { saveWeddingInfo, getWeddingInfo } from "../firebase";
import { WeddingInfo } from "../types/wedding";

const WeddingInfoComponent: React.FC = () => {
  const initialWeddingInfo: WeddingInfo = {
    groom: {
      name: "",
      fatherName: "",
      motherName: "",
      bankAccounts: {
        self: {
          bankName: "",
          accountNumber: "",
        },
        father: {
          bankName: "",
          accountNumber: "",
        },
        mother: {
          bankName: "",
          accountNumber: "",
        },
      },
    },
    bride: {
      name: "",
      fatherName: "",
      motherName: "",
      bankAccounts: {
        self: {
          bankName: "",
          accountNumber: "",
        },
        father: {
          bankName: "",
          accountNumber: "",
        },
        mother: {
          bankName: "",
          accountNumber: "",
        },
      },
    },
    venue: {
      name: "",
      address: "",
      latitude: 0,
      longitude: 0,
    },
    date: "",
    time: "",
    invitationMessage: "",
    directions: "",
    parallaxSubtitle: "",
  };

  const [weddingInfo, setWeddingInfo] =
    useState<WeddingInfo>(initialWeddingInfo);

  useEffect(() => {
    const fetchWeddingInfo = async () => {
      try {
        const data = await getWeddingInfo();
        if (data) {
          setWeddingInfo((prev) => ({
            ...prev,
            ...data,
            groom: {
              ...prev.groom,
              ...data.groom,
              bankAccounts: {
                ...prev.groom.bankAccounts,
                ...data.groom.bankAccounts,
              },
            },
            bride: {
              ...prev.bride,
              ...data.bride,
              bankAccounts: {
                ...prev.bride.bankAccounts,
                ...data.bride.bankAccounts,
              },
            },
            venue: {
              ...prev.venue,
              ...data.venue,
            },
          }));
        }
      } catch (error) {
        console.error("Error fetching wedding info:", error);
      }
    };

    fetchWeddingInfo();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    // 중첩된 객체 속성 처리
    if (name.includes(".")) {
      const keys = name.split(".");
      setWeddingInfo((prev) => {
        const newState = { ...prev };
        let current: any = newState;

        // 마지막 키 전까지 순회
        for (let i = 0; i < keys.length - 1; i++) {
          current = current[keys[i]];
        }

        // 마지막 키에 값 설정
        current[keys[keys.length - 1]] = value;
        return newState;
      });
    } else {
      // 일반 속성 처리
      setWeddingInfo((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await saveWeddingInfo(weddingInfo);
      alert("저장되었습니다.");
    } catch (error) {
      console.error("Error saving wedding info:", error);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">예식 정보 관리</h2>
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* 신랑 정보 */}
          <div className="col-md-6 mb-4">
            <div className="card border-primary">
              <div className="card-header bg-primary text-white">
                <h3 className="card-title mb-0">신랑 정보</h3>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">신랑 이름</label>
                  <input
                    type="text"
                    name="groom.name"
                    value={weddingInfo.groom.name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신랑 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.self.bankName"
                        value={weddingInfo.groom.bankAccounts.self.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.self.accountNumber"
                        value={
                          weddingInfo.groom.bankAccounts.self.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">신랑 아버지 이름</label>
                  <input
                    type="text"
                    className="form-control"
                    name="groom.fatherName"
                    value={weddingInfo.groom.fatherName}
                    onChange={handleChange}
                    placeholder="신랑 아버지 이름"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신랑 어머니 이름</label>
                  <input
                    type="text"
                    className="form-control"
                    name="groom.motherName"
                    value={weddingInfo.groom.motherName}
                    onChange={handleChange}
                    placeholder="신랑 어머니 이름"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신랑 아버지 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.father.bankName"
                        value={weddingInfo.groom.bankAccounts.father.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.father.accountNumber"
                        value={
                          weddingInfo.groom.bankAccounts.father.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">신랑 어머니 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.mother.bankName"
                        value={weddingInfo.groom.bankAccounts.mother.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="groom.bankAccounts.mother.accountNumber"
                        value={
                          weddingInfo.groom.bankAccounts.mother.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 신부 정보 */}
          <div className="col-md-6 mb-4">
            <div className="card border-danger">
              <div className="card-header bg-danger text-white">
                <h3 className="card-title mb-0">신부 정보</h3>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">신부 이름</label>
                  <input
                    type="text"
                    name="bride.name"
                    value={weddingInfo.bride.name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신부 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.self.bankName"
                        value={weddingInfo.bride.bankAccounts.self.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.self.accountNumber"
                        value={
                          weddingInfo.bride.bankAccounts.self.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">신부 아버지 이름</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bride.fatherName"
                    value={weddingInfo.bride.fatherName}
                    onChange={handleChange}
                    placeholder="신부 아버지 이름"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신부 어머니 이름</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bride.motherName"
                    value={weddingInfo.bride.motherName}
                    onChange={handleChange}
                    placeholder="신부 어머니 이름"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">신부 아버지 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.father.bankName"
                        value={weddingInfo.bride.bankAccounts.father.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.father.accountNumber"
                        value={
                          weddingInfo.bride.bankAccounts.father.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">신부 어머니 계좌 정보</label>
                  <div className="row g-2">
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.mother.bankName"
                        value={weddingInfo.bride.bankAccounts.mother.bankName}
                        onChange={handleChange}
                        placeholder="은행명"
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="bride.bankAccounts.mother.accountNumber"
                        value={
                          weddingInfo.bride.bankAccounts.mother.accountNumber
                        }
                        onChange={handleChange}
                        placeholder="계좌번호"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 예식장 정보 */}
          <div className="col-12 mb-4">
            <div className="card mb-4 border-info">
              <div className="card-header bg-info text-white">
                <h3 className="card-title mb-0">예식장 정보</h3>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">예식장 이름</label>
                  <input
                    type="text"
                    name="venue.name"
                    value={weddingInfo.venue.name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">주소</label>
                  <input
                    type="text"
                    name="venue.address"
                    value={weddingInfo.venue.address}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">위도</label>
                    <input
                      type="number"
                      step="any"
                      name="venue.latitude"
                      value={weddingInfo.venue.latitude}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">경도</label>
                    <input
                      type="number"
                      step="any"
                      name="venue.longitude"
                      value={weddingInfo.venue.longitude}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">오시는 길 안내</label>
                  <ReactQuill
                    theme="snow"
                    value={weddingInfo.directions}
                    onChange={(value) =>
                      setWeddingInfo((prev) => ({ ...prev, directions: value }))
                    }
                    placeholder="지하철, 버스, 주차 정보 등 상세 안내를 입력하세요."
                    style={{ height: "200px", marginBottom: "4rem" }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 예식 일시 */}
          <div className="col-12 mb-4">
            <div className="card border-info">
              <div className="card-header bg-info text-white">
                <h3 className="card-title mb-0">예식 일시</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">날짜</label>
                    <input
                      type="date"
                      name="date"
                      value={weddingInfo.date}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">시간</label>
                    <input
                      type="time"
                      name="time"
                      value={weddingInfo.time}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary btn-lg">
            정보 저장
          </button>
        </div>
      </form>
    </div>
  );
};

export default WeddingInfoComponent;
